import React, {useContext} from 'react'
import {useTranslation} from 'react-i18next'

import {SideModal} from '~/components/general/modal/SideModal'
import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'
import {Button} from '~/components/general/button/Button'
import {
  NotificationContext,
  NotificationType,
} from '~/components/notifications/NotificationContext'
import {useDeletePartnerService} from '~/api/partnerAdminServices'

type DeleteServiceModalProps = {
  isVisible: boolean
  onClose: () => void
  serviceId: string | null
}

export const DeleteServiceModal: React.FC<DeleteServiceModalProps> = ({
  isVisible,
  onClose,
  serviceId,
}) => {
  const {t} = useTranslation<string>()
  const {addNotification} = useContext(NotificationContext)

  const {mutateAsync: deleteService, isPending} = useDeletePartnerService(
    serviceId || '',
  )

  const handleConfirm = async () => {
    if (!serviceId) return
    try {
      await deleteService()
      onClose()
    } catch (error) {
      addNotification(
        error instanceof Error ? error.message : t('Unknown error occurred'),
        NotificationType.Error,
      )
    }
  }

  return (
    <SideModal
      isVisible={isVisible}
      onClose={onClose}
      header={
        <Container>
          <Typography size="lg" weight="medium">
            {t('Delete service')}
          </Typography>
        </Container>
      }>
      <Container flex direction="column" spacing={3}>
        <Typography>
          {t(
            'This action can only be completed if no slots exist for this service.',
          )}
        </Typography>
        <Container flex justify="flex-end" spacing={2}>
          <Button color="secondary" onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button onClick={handleConfirm} disabled={isPending}>
            {t('Confirm')}
          </Button>
        </Container>
      </Container>
    </SideModal>
  )
}
